import clsx from 'clsx';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { Input } from '@/components/input/input';

import { ExampleTypeSelect } from './ExampleTypeSelect';
import styles from './modalSourceCreate.module.scss';

type SnowflakeConfigFieldsProps = {
  isPending?: boolean;
  isVersionMode: boolean;
};

export const SnowflakeConfigFields: React.FC<SnowflakeConfigFieldsProps> = ( {
  isPending,
  isVersionMode
} ) => {
  const { register, formState: { errors } } = useFormContext();
  const configErrors = ( errors.config ?? {} ) as Record<string, { message?: string }>;

  return (
    <section className={ styles.config_section }>
      <h3 className={ styles.config_section_title }>Configure Snowflake Properties</h3>

      <div className={ styles.config_grid }>
        <div className={ clsx( 'layout__col', 'pad' ) }>
          <label
            className={ clsx( 'auth_flow_label', configErrors.database_name && 'required' ) }
            htmlFor="config.databaseName"
          >
            Database Name <span className={ styles.required_asterisk }>*</span>
          </label>
          <Input
            id="config.databaseName"
            type="text"
            data-testid="source-config-snowflake-database-name"
            disabled={ isPending }
            error={ configErrors.database_name && ( configErrors.database_name.message || 'Database name is required' ) }
            { ...register( 'config.database_name' ) }
          />
        </div>

        <div className={ clsx( 'layout__col', 'pad' ) }>
          <label
            className={ clsx( 'auth_flow_label', configErrors.schema_name && 'required' ) }
            htmlFor="config.schemaName"
          >
            Schema Name
          </label>
          <Input
            id="config.schemaName"
            type="text"
            data-testid="source-config-snowflake-schema-name"
            disabled={ isPending }
            error={ configErrors.schema_name?.message }
            { ...register( 'config.schema_name' ) }
          />
        </div>

        <div className={ clsx( 'layout__col', 'pad' ) }>
          <label
            className={ clsx( 'auth_flow_label', configErrors.credential_ref && 'required' ) }
            htmlFor="config.credentialRef"
          >
            Credential Reference <span className={ styles.required_asterisk }>*</span>
          </label>
          <Input
            id="config.credentialRef"
            type="text"
            data-testid="source-config-snowflake-credential-reference"
            disabled={ isPending }
            error={ configErrors.credential_ref && ( configErrors.credential_ref.message || 'Credential reference is required' ) }
            { ...register( 'config.credential_ref' ) }
          />
        </div>

        <div className={ clsx( 'layout__col', 'pad', styles.config_grid_full ) }>
          <label
            className={ clsx( 'auth_flow_label', configErrors.query && 'required' ) }
            htmlFor="config.query"
          >
            Query <span className={ styles.required_asterisk }>*</span>
          </label>
          <textarea
            className={ clsx( styles.query_textarea, configErrors.query && styles.input_error ) }
            id="config.query"
            data-testid="source-config-snowflake-query"
            disabled={ isPending }
            { ...register( 'config.query' ) }
          />
          {configErrors.query && (
            <div className={ styles.error_message }>
              {configErrors.query.message || 'Query is required'}
            </div>
          )}
        </div>
      </div>

      <ExampleTypeSelect disabled={ isVersionMode || isPending } />
    </section>
  );
};
